import { render, staticRenderFns } from "./purchase-change-drawer.vue?vue&type=template&id=5323e431&scoped=true"
import script from "./purchase-change-drawer.vue?vue&type=script&lang=js"
export * from "./purchase-change-drawer.vue?vue&type=script&lang=js"
import style0 from "./purchase-change-drawer.vue?vue&type=style&index=0&id=5323e431&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323e431",
  null
  
)

export default component.exports